module.exports = __webpack_public_path__ + "img/lac-discord.32552125.png";